import React,{useState, useEffect} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import IconButton from '@mui/material/IconButton';
import EventIcon from '@mui/icons-material/Event';
import dayjs from 'dayjs';
import ErrorIcon from '@mui/icons-material/Error';
import {Button, TextField} from '@mui/material'; 
import { BrowserRouter, useHistory } from "react-router-dom";
import {AcepHeaderLogo_RedirectURL, CMEAccountURL, STATE_LICENSING_BOARDS_URL, ACCREDITATION_CONSENT_SITES} from '../../config/config'
import MyDatePicker from '../common/MyDatePicker';
export const Form = ({ onSubmit,onProfileCategoryChanges,onRequirerBoardChanges,handleChangeLicRenDate,inputProperties,onKeyPress,profileCategory,stateOrSpecialtyBoard,filterProps,modalFor,closeModal,topicLoaded,closeModalCustomClick,cancelBtnRef,currentProfessionalStatus,isFirstTimeAttestation }) => {
  const history = useHistory();

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedProfessionalStatus, setSelectedProfessionalStatus] = useState(isFirstTimeAttestation ? null : currentProfessionalStatus);
  const [parsConsentChecked, setParsConsentChecked] = useState(false);
  const [parsConsentError, setParsConsentError] = useState(false);
  const [showAll, setShowAll] = useState(false);

  // Update selection when currentProfessionalStatus changes
  useEffect(() => {
    setSelectedProfessionalStatus(isFirstTimeAttestation ? null : currentProfessionalStatus);
  }, [currentProfessionalStatus, isFirstTimeAttestation]);

  const handleDateChange = (date) => {
    const currentDate = dayjs(new Date());
    if (isNaN(date)) {     
      setSelectedDate(null);  return;
    }  
    
  
    if(document.getElementsByClassName('date-picker-modal')[0]){
      document.getElementsByClassName('date-picker-modal')[0].style.display = 'none';
  }
   setSelectedDate(date);
    // other logic if needed
  };

  const handleEndDateChange = (date) => {
    const currentDate = dayjs(new Date());
    if (isNaN(date)) {     
      setSelectedEndDate(null);  return;
    }  

    if(document.getElementsByClassName('end-date-picker-modal')[0]){
        document.getElementsByClassName('end-date-picker-modal')[0].style.display = 'none';
    }

    setSelectedEndDate(date);
    // other logic if needed
  };

  const handleStartDateChange = (date) => {
    const currentDate = dayjs(new Date());
    if (isNaN(date)) {     
      setSelectedStartDate(null);  return;
    }  

    if(document.getElementsByClassName('date-picker-modal')[0]){
      document.getElementsByClassName('date-picker-modal')[0].style.display = 'none';
    }

    setSelectedStartDate(date);
    // other logic if needed
  };

  const handleFormSubmit = (e) => {
    if (modalFor === 'PARSConsent') {
      e.preventDefault();
      if (!parsConsentChecked) { setParsConsentError(true); return; }
      onSubmit(e);
    } else if (modalFor === 'UpdateProfile') {
      e.preventDefault();
      onSubmit(e);
    } else if (modalFor === 'ProfessionalStatus') {
      e.preventDefault();
      if (selectedProfessionalStatus) {
        onSubmit(selectedProfessionalStatus, closeModal, e);
      }
    } else {
      onSubmit(e);
    }
  };

  return ( 
    <form onSubmit={handleFormSubmit} modalfor={modalFor} className={modalFor=== "Requirements"? "form-container-requirement" : "form-container"} style={modalFor === "MobileUser" ? {padding: '0 0 50px 0'} : {}}>
        <label style={{color:'red'}}></label>
        {modalFor == "MobileUser" ?
        <div style={{textAlign: 'center', padding: '0 24px 8px'}}>
          <div style={{marginBottom: '12px'}}>
            <a href={AcepHeaderLogo_RedirectURL} target="_blank" rel="noreferrer">
              <img src="/ACEP Mobile App.png" alt="ACEP Mobile App" style={{width: '64px', height: '64px', borderRadius: '14px', cursor: 'pointer'}} />
            </a>
          </div>
          <div style={{fontWeight: '700', fontSize: '24px', marginBottom: '16px', fontFamily: 'Source Sans Pro'}}>
            Continue in App
          </div>
          <div style={{color: '#555555', fontSize: '16px', lineHeight: '1.5', marginBottom: '24px', fontFamily: 'Source Sans Pro'}}>
            For the best experience, download the ACEP Mobile App and sign in, or continue on a desktop or tablet.
          </div>
          <Button
            variant="contained"
            style={{backgroundColor: '#1976D2', color: '#FFFFFF', textTransform: 'none', width: '100%', padding: '12px 16px', borderRadius: '8px', fontSize: '16px', fontFamily: 'Source Sans Pro', fontWeight: '600', marginBottom: '20px', boxShadow: 'none', whiteSpace: 'nowrap'}}
            onClick={() => {
              const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
              const url = isIOS
                ? 'https://apps.apple.com/us/app/acep-mobile/id1623855450'
                : 'https://play.google.com/store/apps/details?id=com.acepmobile&hl=en_US';
              window.open(url, '_blank');
            }}
          >
            Download ACEP Mobile App
          </Button>
          <div
            onClick={closeModalCustomClick}
            style={{fontWeight: '700', fontSize: '16px', cursor: 'pointer', color: '#000000', fontFamily: 'Source Sans Pro'}}
          >
            Close
          </div>
        </div>
      
        :
        modalFor == "Add" ?
        <div >
          <div className="form-group">
            <label  className='model-input-label'  htmlFor="name">Licensing Board Type</label>
            <select required  
            onChange={onProfileCategoryChanges}
            className="form-control model-input">
              <option  value={-1}></option>
                {profileCategory.map((option) => (
                  <option  value={option.Id}>{option.Name}</option>
                ))}
              </select> 
          </div>
          <div className="form-group">
            <label className='model-input-label' htmlFor="email ">Licensing Board Name</label>
            <select  required   
             onChange={onRequirerBoardChanges}        
            className="form-control model-input">
                {stateOrSpecialtyBoard.map((option) => (
                  <option value={option.Id}>{option.Name}</option>
                ))}
              </select>      
          </div>
          <div className="form-group">
            <label className='model-input-label' htmlFor="LicRendate">License Expiration Date</label>
            <div className="date-picker-container">
          <MyDatePicker
            defaultValue={selectedDate ? selectedDate : null}
            selected={selectedDate}
            onChange={handleDateChange}
            disablePastDates
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            className=" form-control model-input "
            id="date"
             
          />
           <span style={{display:"none"}} className='date-picker-modal error-message-cme-hours'>
                                <span className='padding_top_5_px'>
                                <ErrorIcon /> {'This field is required and date must be in the future.'}
                                </span>
            </span> 
        </div>
            
          </div>
      </div>
        :  modalFor == "Requirements" ? 
         
        <div style={{paddingTop:"30px"}}>   
        {topicLoaded ? 
        <span style={{whiteSpace: "pre-line"}}> {(inputProperties)}</span>
        : 
        <span style={{whiteSpace: "pre-line"}}> {(inputProperties.modalData)}</span>
        }
          <a href='' style={{transform:'none',border:'none'}} ></a>
        </div>          
        : modalFor == "Edit Profile" ?
        
        <div className="form-group">
          <label className='model-input-label' htmlFor="LicRendate">License Expiration Date</label>
          <TextField required
            type="date"
            onChange={handleChangeLicRenDate}
            defaultValue= {inputProperties.RecertificationDate}
            InputProps={{
              inputProps: {
                min:new Date().toISOString().split('T')[0]
              },
            }}  
            
            className="form-control model-input"
          />
          
        </div>
         :  modalFor == "Add Requirer" ? 
         <>
             <div className="form-group">
             <label  className='model-input-label'  htmlFor="name">Licensing Board Type</label>
             <select required  
             
             className="form-control model-input">
                 { profileCategory.map((option) => (
                   <option  value={option.Id}>{option.Name}</option>
                 ))} 
               </select> 
           </div>
           <div className="form-group">
             <label className='model-input-label' htmlFor="email ">Licensing Board Name</label>
             <input  required   type="text"    
             className="form-control model-input">
                 
               </input>      
             </div>
           <div className="form-group">
             <label className='model-input-label' htmlFor="LicRendate">Website</label>
             <input required
               type="text"
               className="form-control model-input"
             />
             
           </div>
         </>
        : modalFor == "Filters" ?
        <div >
          <div className='form-group'>
              <label className='model-input-label' htmlFor="date">Date</label>
              <select required id='date'
              onChange={filterProps[2].onchangeDateRange}
                className="form-control model-input filters-date">
                   <option  value="All Time">All Time</option> 
                   <option  value="Last 30 Days">Last 30 Days</option>
                   <option  value="Last 6 Months">Last 6 Months</option>
                   <option  value="Year To Date (YTD)">Year To Date (YTD)</option>           
                   <option  value="Date Range">Date Range</option>  
              </select>
          </div>

         <div className={filterProps[1].toShowSelectFiltersDateRange ? 'form-group ' :'form-group display-none' }>
            <div className='width_45_percent float_left' > 
            <label className='model-input-label' htmlFor="startdate">Start Date</label>
             { filterProps[1].toShowSelectFiltersDateRange ?
                  <div className="date-picker-container">
                  <MyDatePicker
                  required
                    selected={selectedStartDate}
                    onChange={handleStartDateChange}                    
                    dateFormat="MM/dd/yyyy"
                    placeholderText="MM/DD/YYYY"
                    defaultValue={selectedStartDate ? selectedStartDate : null}
                    className="form-control model-input filters-start-date"
                    id="date"
                  />
                   <span style={{display:"none", maxWidth:'135px'}} className='date-picker-modal error-message-cme-hours'>
                                <span style={{width:'135px'}} className='padding_top_5_px'>
                                <ErrorIcon /> {'This field is required.'}
                                </span>
            </span> 
                </div>
              // <TextField required 
              // className="form-control model-input"    
              // data-date-format="DD MMMM YYYY" 
              // type="date" id='startdate' ></TextField>
              :
            <div className="date-picker-container">  <MyDatePicker
                  required
                    selected={selectedStartDate}
                    onChange={handleStartDateChange}                    
                    dateFormat="MM/dd/yyyy"
                    placeholderText="MM/DD/YYYY"
                    defaultValue={selectedStartDate ? selectedStartDate : null}
                    className="form-control model-input filters-start-date"
                    id="date"
                  />
                   <span style={{display:"none", maxWidth:'135px'}} className='date-picker-modal error-message-cme-hours'>
                                <span style={{width:'135px'}} className='padding_top_5_px'>
                                <ErrorIcon /> {'This field is required.'}
                                </span>
            </span> 
                  </div>
              // <TextField 
              // className="form-control model-input"  
              // data-date-format="DD MMMM YYYY" 
              // type="date" id='startdate' >

              // </TextField>
            }</div>
            <div className='width_45_percent float_right' >
            <label className='model-input-label' htmlFor="enddate">End Date</label> 
            { filterProps[1].toShowSelectFiltersDateRange ?
              // <TextField required className="form-control model-input"   type="date" id='enddate' ></TextField>
              <div className="date-picker-container"><MyDatePicker  
              required             
                selected={selectedEndDate}
                onChange={handleEndDateChange}                    
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/DD/YYYY"
                className="form-control model-input filters-end-date"
                defaultValue={selectedEndDate ? selectedEndDate : null}
                id="date"
              />
              <span style={{display:"none", maxWidth:'135px'}} className='end-date-picker-modal error-message-cme-hours'>
                                <span style={{width:'135px'}} className='padding_top_5_px'>
                                <ErrorIcon /> {'This field is required.'}
                                </span>
            </span> 
              </div>
              :
              // <TextField  className="form-control model-input"    type="date" id='enddate' ></TextField>
             <> <MyDatePicker
              required
                 selected={selectedEndDate}
                onChange={handleEndDateChange}                    
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/DD/YYYY"
                defaultValue={selectedEndDate ? selectedEndDate : null}
                className="form-control model-input filters-end-date"
                id="date"
              />
 <span style={{display:"none",maxWidth:'135px'}} className='end-date-picker-modal error-message-cme-hours'>
                                <span style={{width:'135px'}} className='padding_top_5_px'>
                                <ErrorIcon /> {'This field is required.'}
                                </span>
            </span> 
              </>
            }       </div>
          </div>
         

          <div className='form-group'>
              <label className='model-input-label' htmlFor="activitytype">Activity Type</label>
              <select required  id='activitytype'             
                className="form-control model-input filters-activity-type">
                 { <option  value="All Activity Types">All Activity Types</option>}
                  { filterProps[3].cmeActivityTypeList.map((option) => (                  
                    <option  value={option.Id}>{option.Name}</option>
              ))}
                </select>
          </div>
          <div className='form-group'>
              <label className='model-input-label' htmlFor="topic">Topic</label>
              <select required id='topic'          
                className="form-control model-input filters-topic" >
                  {
                    <option  value='All Topics'>All Topics</option>
                  }
                 { filterProps[0].cmeTopicList.map((option) => (                  
                    <option  value={option.Id}>{option.Name}</option>
              ))}
                 
                </select>
          </div>

          <div className='form-group'>
              <label className='model-input-label' htmlFor="topic">Accreditation Source</label>          
                <select required id='accreditationSource'    
                className="form-control model-input filters-accreditation-source">
                   <option value='All Accreditation Sources'>All Accreditation Sources</option>
                    <option value='ACEP Accredited'>ACEP Accredited</option>
                    <option value='Self-Reported'>Self-Reported</option>  
              </select>
          </div>
          
        </div>
        : modalFor == "Certificates" ?
        <div style={{paddingTop:"30px", paddingLeft:'20px'}}>          
        <span style={{whiteSpace: "pre-line"}}> 
        <ul style={{listStyle:"disc"}}>{inputProperties.modalData.split(',').map(data => {
          return <li style={{listStyle:"disc"}}>{data}</li>
           
        })}</ul>
        </span>
        <input className='no-border-input' style={{border:'none !important'}}></input>
        </div> 
        : modalFor === 'MergeCME' ?
        <div>Are you sure you want to merge all CME activities? This action cannot be undone.</div>
        : modalFor === 'RestoreDeletedActivity' ?
        <div>Are you sure you want to restore this deleted Activity?</div>
        : modalFor === 'UnclaimActivity' ?
        <div>Are you sure you want to unclaim this activity? <span className='modal-body-warning-text'>Any added topic and hours will be deleted.</span> This action cannot be undone.</div>
        : modalFor === 'UpdateProfile' ?
        <div>
          <div className='modal-body-description'>
            Please update missing profile information below, in order for ACEP to submit your credits to state licensing boards.
          </div>
          <ul className='modal-missing-fields-list'>
            {(inputProperties?.missingFields || []).map((field) => (
              <li key={field}>{field}</li>
            ))}
          </ul>
          <input className='no-border-input' />
        </div>
        : modalFor === 'PARSConsent' ?
        <div>
          <div className='pars-consent-description'>
            In addition to claiming your CME hours, would you like ACEP to submit your credits
            to your state licensing boards via {ACCREDITATION_CONSENT_SITES}?{' '}
            <a
              href={STATE_LICENSING_BOARDS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="pars-consent-link"
            >
              View participating boards.
            </a>
          </div>
          <label className='pars-consent-checkbox-label'>
            <input
              type="checkbox"
              checked={parsConsentChecked}
              onChange={(e) => { setParsConsentChecked(e.target.checked); if (e.target.checked) setParsConsentError(false); }}
              className='pars-consent-checkbox'
            />
            <span>I authorize ACEP to submit my credits to state licensing boards via {ACCREDITATION_CONSENT_SITES}.</span>
          </label>
          {parsConsentError && (
            <div className='modal-field-error-text'>
              Check box required if user click Yes
            </div>
          )}
          <input className='no-border-input' />
        </div>
        : modalFor === 'ProfessionalStatus' ?
        <div>
          <div style={{ marginBottom: '20px' }}> </div>
          <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <div
              onClick={() => setSelectedProfessionalStatus('physician')}
              style={{
                height: '204px',
                backgroundColor: selectedProfessionalStatus === 'physician' ? '#1976D2' : '#E9E9E9',
                color: selectedProfessionalStatus === 'physician' ? '#FFFFFF' : '#1976D2',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontFamily: 'Source Sans Pro',
                fontWeight: '600',
                fontStyle: 'normal',
                fontSize: '24px',
                lineHeight: '100%',
                letterSpacing: '0px',
                verticalAlign: 'middle'
              }}
            >
              Physician Certificate
            </div>
            <div
              onClick={() => setSelectedProfessionalStatus('healthcare')}
              style={{
                height: '204px',
                backgroundColor: selectedProfessionalStatus === 'healthcare' ? '#1976D2' : '#E9E9E9',
                color: selectedProfessionalStatus === 'healthcare' ? '#FFFFFF' : '#1976D2',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontFamily: 'Source Sans Pro',
                fontWeight: '600',
                fontStyle: 'normal',
                fontSize: '24px',
                lineHeight: '130%',
                letterSpacing: '1px',
                verticalAlign: 'middle'
              }}
            >
              Other Healthcare<br />Provider Certificate
            </div>
          </div>

        </div>
       : modalFor === 'DeadlineWarning' ?
        <div style={{ paddingTop: '16px' }}>
          <div className='modal-body-description' style={{ fontSize: '16px' }}>
            The following CME activities are approaching their claim deadlines. Claim now to avoid losing credits. Please review other activities that may be expiring soon.
          </div>
          <ul className='pars-deadline-warning-list'>
            {(showAll ? inputProperties.approachingItems : inputProperties.approachingItems.slice(0, 3)).map((it, idx) => (
              <li key={idx} style={{ marginBottom: '14px', fontSize: '16px' }}>
                <div>{it.Name}</div>
                <div>
                  <strong>Deadline: {it.FormatActivityEndDate} – </strong>
                  <strong style={{ color: '#E44040' }}>
                    {it.daysRemaining === 0 ? 'Expiring today' : `${it.daysRemaining} days remaining`}
                  </strong>
                </div>
              </li>
            ))}
          </ul>
          {inputProperties.approachingItems.length > 3 && !showAll && (
            <button
              type="button"
              onClick={() => setShowAll(true)}
              className='pars-deadline-show-more'
            >
              Show More ({inputProperties.approachingItems.length - 3} more)
            </button>
          )}
          <input className='no-border-input' />
        </div>
       : <div className='delete-operation-message'>
          Are you sure you want to delete this?
          <input className='no-border-input' style={{border:'none !important'}}></input>
        </div>
        }
    
       {modalFor !== 'Requirements' && 
       <div className="form-group" style={{ paddingTop:modalFor === 'Delete' ?'64px': modalFor === 'MobileUser' ? '0' :'40px',paddingBottom:modalFor === 'Delete' ?'64px': modalFor === 'MobileUser' ? '0' :'40px',float:"right"}}>
       {
        modalFor == "Certificates" ?
        <Button variant="outlined" 
            onMouseDown={onKeyPress}
            style={{width:inputProperties && (inputProperties.showExportButton) ? '50%':'100%', textTransform: 'none',background: 'red',transition:'none !important'}}
            onClick={closeModal} className='model-cancel-button' type='closeModal'>
               <div style={{color:'#1976D2'}} className='popup-button-text'>Cancel</div> 
            </Button>
            :
            modalFor == "MobileUser" ?
              <Button variant="outlined"
                 ref={cancelBtnRef}
                 onMouseDown={onKeyPress}
                 style={{display:'none'}}
                 onClick={closeModal} className='model-cancel-button close-button' type='closeModal'>
                    <div style={{color:'#1976D2'}} className='popup-button-text'>
                    Cancel
                     </div>
                 </Button>
                :
            modalFor == "ProfessionalStatus" ?
            null
            :
            modalFor === 'PARSConsent' ?
            <Button variant="outlined"
              onMouseDown={onKeyPress}
              style={{textTransform: 'none',background: 'red',transition:'none !important'}}
              onClick={closeModalCustomClick} className='model-cancel-button' type='button'>
              <div style={{color:'#1976D2'}} className='popup-button-text'>No, add to transcript only</div>
            </Button>
            :
            modalFor === 'DeadlineWarning' ? null
            :
            <Button variant="outlined"
            onMouseDown={onKeyPress}
            style={{textTransform: 'none',background: 'red',transition:'none !important'}}
            onClick={closeModal} className='model-cancel-button' type='closeModal'>
               <div style={{color:'#1976D2'}} className='popup-button-text'>
               Cancel
                </div>
            </Button>
       }
           
            {modalFor == "Add" ?  
            <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border'    type="submit">
                Save
              </Button> :
              modalFor == "Edit Profile" ?  
              <Button variant="contained" className='model-submit-button modal-submit-background-color model-submit-button-border'    type="submit">
                  Save
                </Button>
                :
                modalFor == "Add Requirer" ?  
                <Button variant="contained" className='model-submit-button modal-submit-background-color model-submit-button-border'    type="submit">
                    Save
                </Button> 
                :modalFor == "Filters" ?  
              <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border' 
                  type="submit">
                  Apply
                </Button>
                :modalFor == "Certificates" && inputProperties.showExportButton ?  
                
                <Button variant="contained"
                
                className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border' 
                    type="submit">
                    Continue to Export Certificate
                  </Button> :
                  modalFor == "MergeCME" ?  
                  <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border'    type="submit">                        
                        Yes, merge
                    </Button> :
                    modalFor == "RestoreDeletedActivity" ?  
                    <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border'    type="submit">                        
                          Yes, restore
                      </Button> :
                    modalFor == "UnclaimActivity" ?  
                    <Button variant="contained"
                    style={{textTransform: 'none',background: '#FFFFFF',transition:'none !important'}}
                    className='model-submit-button color-red model-delete-button-border'  type="submit">
                    <div style={{color:'#FFFFFF'}} className='popup-button-text'>Yes, unclaim</div>
                    </Button> :
                    modalFor == "ProfessionalStatus" ?  
                    <Button
                      variant="contained"
                      className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border'
                      style={{
                        opacity: isFirstTimeAttestation ? (selectedProfessionalStatus ? "1" : "0.4") : (selectedProfessionalStatus && selectedProfessionalStatus !== currentProfessionalStatus) ? "1" : "0.4",
                        pointerEvents: isFirstTimeAttestation ? (selectedProfessionalStatus ? "auto" : "none") : (selectedProfessionalStatus && selectedProfessionalStatus !== currentProfessionalStatus) ? "auto" : "none",
                        cursor: isFirstTimeAttestation ? (selectedProfessionalStatus ? 'pointer' : 'not-allowed') : (selectedProfessionalStatus && selectedProfessionalStatus !== currentProfessionalStatus) ? 'pointer' : 'not-allowed'
                      }}
                      type="submit"
                      disabled={isFirstTimeAttestation ? !selectedProfessionalStatus : (!selectedProfessionalStatus || selectedProfessionalStatus === currentProfessionalStatus)}
                      data-analytics={
                        selectedProfessionalStatus
                          ? (isFirstTimeAttestation
                              ? (selectedProfessionalStatus === 'physician'
                                  ? 'First Time Attest as Physician'
                                  : 'First Time Attest as Healthcare Provider')
                              : (selectedProfessionalStatus === 'physician'
                                  ? 'Attest as Physician'
                                  : 'Attest as Healthcare Provider'))
                          : ''
                      }
                      >
                          <b className="color_white">Save and Continue</b>
                      </Button> :
                  modalFor === 'PARSConsent' ?
                  <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border' type="submit">
                    Yes
                  </Button> :
                  modalFor === 'UpdateProfile' ?
                  <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border' type="submit">
                    Update via My Account
                  </Button> :
                  modalFor === 'DeadlineWarning' ?
                  <Button variant="contained" className='model-submit-button modal-submit-background-color text_transform_none model-submit-button-border' type="submit">
                    Close
                  </Button> :
                  modalFor !== "Certificates" && modalFor !== "MobileUser" && modalFor !== "ProfessionalStatus" &&
              <Button variant="contained"
              style={{textTransform: 'none',background: '#FFFFFF',transition:'none !important'}}
              className='model-submit-button color-red model-delete-button-border'  type="submit">
              <div style={{color:'#FFFFFF'}} className='popup-button-text'>Delete</div>
              </Button>
      }
      </div>}
    </form>
  );
};
export default Form;

